interface byNone {
  element?: never;
  id?: never;
  className?: never;
}
interface byElement {
  element: Element;
  id?: never;
  className?: never;
}
interface byId {
  id: string;
  element?: never;
  className?: never;
}
interface byClass {
  className: string;
  element?: never;
  id?: never;
}
export type ElementTargetProps = byElement | byId | byClass | byNone;

/**
 * Select an element, by specified Element, id, or className.
 * Takes a list of selectors, allowing fallbacks.
 */
export const getElementBySelection = (
  ...targetRules: ElementTargetProps[]
): Element => {
  const [targetRule, ...rest] = targetRules;
  if ("element" in targetRule && targetRule.element) {
    return targetRule.element;
  }
  if ("id" in targetRule && targetRule.id) {
    const elem = document.getElementById(targetRule.id);
    if (elem) {
      return elem;
    }
  }
  if ("className" in targetRule && targetRule.className) {
    return document.getElementsByClassName(targetRule.className)[0];
  }

  return getElementBySelection(...rest);
};
